export enum AnalyticsReportAgentRunStatus {
  Running = "running",
  Succeeded = "succeeded",
  Failed = "failed",
}
